import React from 'react';
import { MainLayout } from '../components/layout';
import { Navigation } from '../components/common/Navigation';
import { SkipLink } from '../components/common/SkipLink';
import { Footer } from '../components/common/Footer';
import { Hero } from '../components/sections/Hero';
import { About } from '../components/sections/About';
import { Portfolio } from '../components/sections/Portfolio';
import { Contact } from '../components/sections/Contact';
import { useScrollSpy } from '../hooks/useScrollSpy';
import { useSmoothScroll } from '../hooks/useSmoothScroll';

const sectionIds = ['hero', 'about', 'portfolio', 'contact', 'privacy'];

export const HomePage: React.FC = () => {
  const activeSection = useScrollSpy(sectionIds);
  const { scrollToSection } = useSmoothScroll();

  const handleNavigate = (sectionId: string) => {
    scrollToSection(sectionId);
  };

  return (
    <div className="app">
      <SkipLink />
      <Navigation activeSection={activeSection} onNavigate={handleNavigate} />
      <MainLayout>
        <Hero onNavigate={handleNavigate} />
        <About />
        <Portfolio />
        <Contact />
      </MainLayout>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
};
